export type LangDict = { [key in string]: string };
export const langs: LangDict = {
  'en-US': 'English',
  'es-MX': 'Español',
  'fr-CA': 'Français',
};
